import { apiDate } from "@/api/apicommon"
import gen from "@/functions/general.js"

export function tLineCs(csDate, startDate, endDate) {
  // Date-Variables for calculation
  const start = startDate.getTime()
  const end = endDate.getTime()
  const cs = csDate.getTime()
  let csLine = {}

  // x
  if (cs < start || cs > end) {
    csLine.x = -1
  } else {
    csLine.x = (cs - start) / (end - start)
  }
  return csLine
}

export function tLineHeader(startDate, endDate) {
  // Create Array with dates (start form endDate, and go back by steps of 1 year until startDate)
  let headerArray = []
  for (let i = endDate.getFullYear(); i >= startDate.getFullYear(); i--) {
    headerArray.push({"date": i})
  }
  // Date-Variables for calculation
  const start = startDate.getTime()
  const end = endDate.getTime()
  let lastDate = end
  let endBool = false
  const arrLen = headerArray.length
  const maxLabels = 10
  const step = (arrLen - 2) / (maxLabels - 2)
  headerArray.forEach((item, index) => {
    // if (arrLen > maxLabels) {
    //   const expectedIndex = Math.round(index / step)
    //   const isIndexWithLabel = Math.round(expectedIndex * step) === index
    //   if (!isIndexWithLabel) return;
    // }

    let itemDate = new Date(item.date, 0, 1).getTime()

    // Add
      // Start and end (Take every 2nd value)
      if (endBool) {
        item.start = "none"
        item.end = "end"
      } else {
        item.start = "start"
        item.end = "none"
      }
      endBool = !endBool;
      // x and width
      if (itemDate < start && item.end == "end") {
        item.x = -1
        item.width = 0
      } else {
        let calcStart = (itemDate < start) ? start : itemDate
        item.x = (calcStart - start) / (end - start)
        item.width = (item.end == "end") ? "0" : (lastDate - calcStart) / (end - start)
      }
      // DateStr
      item.dateStr = item.date.toString()
      if (arrLen <= maxLabels) {
        item.dateStr = item.date.toString()
      } else {
        const expectedIndex = Math.round(index / step)
        const isIndexWithLabel = Math.round(expectedIndex * step) === index
        item.dateStr = isIndexWithLabel ? item.date.toString() : ''
      }
    // Store variable before next iteration
    lastDate = itemDate
    return item
    })
  return headerArray
}

export function tLineExpressions(originalExpressions, tlStartDate, tlEndDate) {
  //expr.durationType can be: None, Once, Duration, Since, Until
  if (originalExpressions) {
    // Dates for TL iteself
    const tlStart = tlStartDate.getTime()
    const tlEnd = tlEndDate.getTime()
    const tlLength = tlEnd - tlStart
    // Dates for TL Items
    let expressions = gen.deepCopy(originalExpressions)
    //expressions = expressions.filter(expr => {return (expr.timelineStart !== null && expr.timelineEnd !== null)})
    expressions = expressions.filter(expr => expr.timelineStart !== null)
    expressions.forEach(expr => {
      //itemStart and itemEnd
      const entryStart = apiDate(expr.entry.entryStart).getTime()
      const exprStart = apiDate(expr.timelineStart).getTime()
      const exprEnd = expr.timelineEnd ? apiDate(expr.timelineEnd).getTime() : tlEnd
      const durationType = expr.durationType
      if (durationType === 'Since' && exprStart < entryStart) {
        expr.itemStart = exprStart
        expr.itemEnd = expr.isOngoing ? tlEnd : entryStart
      } else if (durationType === 'Until' && entryStart < exprStart) {
        expr.itemStart = entryStart
        expr.itemEnd = exprStart
      } else if (durationType === 'Duration') {
        expr.itemStart = exprStart
        expr.itemEnd = exprEnd
      } else {
        //includes 'Once'
        expr.itemStart = exprStart
        expr.itemEnd = exprStart        
      }      
    })
    expressions.sort((a, b) => {
      return new Date(b.itemStart).getTime() - new Date(a.itemStart).getTime() || new Date(b.updated).getTime() - new Date(a.updated).getTime();
    })

    //Add TL-Data
    let lastItemStart = tlEnd
    expressions.forEach((expr, index) => {
      const durationType = expr.durationType
      const itemStart = expr.itemStart
      const itemEnd = expr.itemEnd

      // Determine rounded borders
      expr.start = (itemStart < tlStart) ? "none" : "rounded"
      expr.end = "rounded"
      //expr.end = ['Once', 'Until', 'Duration'].includes(durationType) ? "rounded" : "none"
      if (index === 0 && durationType === 'Since' & expr.isOngoing) {expr.end = "none"}

      // Accessing previous iteration (except for the first iteration)
      if (index > 0 && (itemStart > tlStart)) {
        const isCurrItemOverlapping = itemEnd > lastItemStart
        // const isPreviousItemAlreadyActive = ['Until'].includes(expressions[index -1].durationType)
        // // Round Borders: if the current item lasts until the next item on the TL (=1 index before): set rounded start-borders to "none"
        // if (isCurrItemLasting) {
        //   expressions[index -1].start = "none" 
        // }
        // Width and x: if the previous items is already active before the current item on the TL: cut its length at the current item
        if (isCurrItemOverlapping) {
        //if (isPreviousItemAlreadyActive && isCurrItemLasting) {       
          //expr.end = "none"
          expressions[index -1].x = (lastItemStart - tlStart) / tlLength
          expressions[index -1].width = "0"          
        }
      }

      // Factor: 1 = 100% pathological  //later on: determine factor from value
      expr.factor = "0.7"
      // Stripes
      expr.stripes = false //(item.asRequired == 1)

      // x and width
      if (lastItemStart < tlStart || itemStart > tlEnd || itemEnd < tlStart) {
        expr.x = -1
        expr.width = 0
      // } else if (itemStart < tlStart && ['Once', 'Until', 'Duration'].includes(durationType)) {
      //   expr.x = -1
      //   expr.width = 0
      } else {
        const calcStart = (itemStart < tlStart) ? tlStart : itemStart
        const calcEnd = (durationType === 'Since' && expr.isOngoing) ? lastItemStart : itemEnd
        expr.x = (calcStart - tlStart) / tlLength
        expr.width = (calcEnd - calcStart) / tlLength 
        // if (['Until'].includes(durationType)) {
        //   expr.start = "None"
        //   expr.x = 0 //=tlStart
        //   expr.width = (itemStart - tlStart) / tlLength
        // } else {
        //   const calcStart = (itemStart < tlStart) ? tlStart : itemStart
        //   expr.x = (calcStart - tlStart) / tlLength
        //   expr.width = ['Once', 'Duration'].includes(durationType) ? "0" : (lastItemStart - calcStart) / tlLength //!=since, !=until
        // }
      }
      // Store variable before next iteration
      lastItemStart = itemStart
      return expr
      })
    return expressions
  }
}
